"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
const ConsoleLogger_1 = require("./core/logging/ConsoleLogger");
const DefaultApplication_1 = require("./core/bootstrapper/DefaultApplication");
const viewModelCollection_1 = require("./viewModelCollection");
const TestPlugin_1 = require("./plugins/TestPlugin");
const HtmlPlugin_1 = require("./plugins/HTMLPlugin/HtmlPlugin");
const logger = new ConsoleLogger_1.ConsoleLogger();
const application = new DefaultApplication_1.DefaultApplication()
    .addLogger(logger)
    .useDatabase(null)
    .addConfigurationManager(null)
    .addSongManager(null)
    .addResourceManager(null)
    .configureContainer((extensions) => {
    extensions.addThemeManager();
    viewModelCollection_1.addViewModels();
    extensions.addPlugin(new TestPlugin_1.TestPlugin("TestPlugin"));
    extensions.addPlugin(new HtmlPlugin_1.HtmlPlugin());
});
application.run("Home");
//# sourceMappingURL=main.js.map